import React from 'react';
import {
  Drawer,
  Box,
  useTheme,
  IconButton,
  Typography,
  Divider,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
  onReload?: () => void;
  renderComponent?: React.ReactNode;
  renderHeader?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SideDrawer: React.FC<SideDrawerProps> = ({
  open,
  onClose,
  renderComponent,
  renderHeader,
  size = 'sm',
}) => {
  const theme = useTheme();

  const getDrawerSize = (size: any) => {
    switch (size) {
      case 'lg':
        return 750;
      case 'md':
        return 450;
      case 'sm':
        return 350;
      default:
        return 350;
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          backgroundColor: theme.palette.background.paper,
          borderTopLeftRadius: theme.spacing(3),
          borderBottomLeftRadius: theme.spacing(3),
          width: getDrawerSize(size),
          height: '100vh',
          boxSizing: 'border-box',
          boxShadow: theme.shadows[5],
          zIndex: 9,
        },
      }}
    >
      <Box
        component="form"
        aria-label="User Form"
        sx={{
          backgroundColor: theme.palette.background.paper,
          height: '100%',
          padding: theme.spacing(3),
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {!!renderHeader && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 2 }}
          >
            <IconButton onClick={onClose}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="body1" sx={{ ml: 2 }}>
              {renderHeader?.toUpperCase()}
            </Typography>
          </Box>
        )}

        <Divider sx={{ mb: 3 }} />
        {renderComponent}
      </Box>
    </Drawer>
  );
};

export default SideDrawer;
